// Property association labels (per kind) and the entity_type / company type
// dropdown options for the Contacts tab dialogs — portal-wide, so fetched
// once per page load and shared by every dialog open.

import { getAPICall, postAPICall } from "../../../config/apiCalls";

export const PROPERTY_LINK_KINDS = ["contact", "company", "entity"];

export const EMPTY_LOOKUPS = { roles: { contact: [], company: [], entity: [] }, entityTypes: [], companyTypes: [] };

let lookupsPromise = null;
export const loadPropertyLinkLookups = (instance, account) => {
	if (!lookupsPromise) {
		lookupsPromise = getAPICall(instance, account, "/api/jobs/property/links/lookups")
			.then((res) => ({ ...EMPTY_LOOKUPS, ...res.data }))
			.catch((err) => {
				lookupsPromise = null; // let the next open retry
				throw err;
			});
	}
	return lookupsPromise;
};

// POST /api/jobs/property/links/save — resolves to { errors, contacts, companies, entities }.
export const savePropertyLinks = (instance, account, propertyId, changes, employeeID) =>
	postAPICall(instance, account, "/api/jobs/property/links/save", { propertyId, ...changes }, employeeID).then((res) => res.data);
